import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Picker } from '@platform/ui';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { IControlProps } from '../IControlProps';
import { choiceOptions } from '../options/choiceOptions';

/**
 * Список вибору й статус (UIUX/field-types/choice-list, status, priority, severity): власний пікер замість нативного select —
 * крапки кольору, «Не вказано» першим (крім статусу; з підказкою — вона, як «—» у клітинках підтаблиць прототипу), пошук понад 7 варіантів,
 * підписи мовою інтерфейсу; значення поза списком варіантів (застарілі дані) показується як є.
 */
export function ChoicePicker({ id, value, onChange, readOnly, field, rt, size, prefix, invalid, placeholder, autoFocus }: IControlProps<string>) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const label = strings.field(rt.key, field.key, field.label);
  const options = useMemo(() => choiceOptions(field, rt, (v, l) => (field.key === 'status'
    ? strings.status(rt.key, v, l)
    : strings.option(rt.key, field.key, v, l)), placeholder ?? t('fieldControls.notSet')), [field, rt, strings, t, placeholder]);
  return (
    <Picker id={id} value={value ?? ''} options={options} onChange={(v) => onChange(v || null)} label={label} prefix={prefix} size={size}
      readOnly={readOnly} invalid={invalid} placeholder={placeholder} autoFocus={autoFocus}
      selected={value ? { value, label: strings.option(rt.key, field.key, value, value) } : null} />
  );
}
